import { createAction } from '@reduxjs/toolkit'

 export const addNotif = createAction<{notifItem:any}>('Notif/add')
 export const reomoveNotif = createAction<{id:number}>('Notif/reomove')
